import React from 'react';
interface DataPoint {
  date: string;
  leads: number;
  cpl: number;
}
const MOCK_DATA: DataPoint[] = [{
  date: 'Jan 01',
  leads: 1500,
  cpl: 80
}, {
  date: 'Jan 02',
  leads: 3500,
  cpl: 100
}, {
  date: 'Jan 03',
  leads: 4000,
  cpl: 90
}, {
  date: 'Jan 04',
  leads: 3200,
  cpl: 110
}, {
  date: 'Jan 05',
  leads: 4500,
  cpl: 130
}, {
  date: 'Jan 06',
  leads: 4200,
  cpl: 140
}, {
  date: 'Jan 07',
  leads: 4000,
  cpl: 150
}, {
  date: 'Jan 08',
  leads: 4300,
  cpl: 145
}, {
  date: 'Jan 09',
  leads: 3800,
  cpl: 155
}, {
  date: 'Jan 10',
  leads: 4600,
  cpl: 150
}, {
  date: 'Jan 11',
  leads: 4100,
  cpl: 145
}, {
  date: 'Jan 12',
  leads: 5000,
  cpl: 130
}, {
  date: 'Jan 13',
  leads: 4500,
  cpl: 140
}, {
  date: 'Jan 14',
  leads: 4800,
  cpl: 135
}, {
  date: 'Jan 15',
  leads: 5200,
  cpl: 130
}, {
  date: 'Jan 16',
  leads: 4700,
  cpl: 135
}, {
  date: 'Jan 17',
  leads: 5300,
  cpl: 140
}, {
  date: 'Jan 18',
  leads: 4900,
  cpl: 145
}, {
  date: 'Jan 19',
  leads: 5500,
  cpl: 150
}, {
  date: 'Jan 20',
  leads: 5100,
  cpl: 155
}, {
  date: 'Jan 21',
  leads: 4800,
  cpl: 160
}, {
  date: 'Jan 22',
  leads: 3800,
  cpl: 165
}, {
  date: 'Jan 23',
  leads: 3200,
  cpl: 155
}, {
  date: 'Jan 24',
  leads: 2000,
  cpl: 140
}, {
  date: 'Jan 25',
  leads: 1800,
  cpl: 120
}, {
  date: 'Jan 26',
  leads: 2200,
  cpl: 110
}, {
  date: 'Jan 27',
  leads: 4000,
  cpl: 160
}, {
  date: 'Jan 28',
  leads: 5000,
  cpl: 180
}];
export function PerformanceTrendChart() {
  const maxLeads = Math.max(...MOCK_DATA.map(d => d.leads));
  const maxCpl = Math.max(...MOCK_DATA.map(d => d.cpl));
  return <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-370">
      <div className="flex items-center justify-between mb-6" data-id="element-371">
        <div data-id="element-372">
          <h3 className="text-base font-semibold text-gray-900 flex items-center" data-id="element-373">
            Performance Trend
            <button className="ml-2 text-gray-400 hover:text-gray-600" data-id="element-374">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-375">
                <circle cx="7" cy="7" r="6" stroke="currentColor" strokeWidth="1.5" data-id="element-376" />
                <path d="M7 4.5V7.5M7 9.5V9.51" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" data-id="element-377" />
              </svg>
            </button>
          </h3>
        </div>
        <div className="flex items-center space-x-6 text-sm" data-id="element-378">
          <div className="flex items-center" data-id="element-379">
            <div className="w-3 h-3 bg-blue-500 rounded-sm mr-2" data-id="element-380"></div>
            <span className="text-gray-600" data-id="element-381">Leads</span>
            <span className="ml-2 font-semibold text-gray-900" data-id="element-382">101.9K</span>
          </div>
          <div className="flex items-center" data-id="element-383">
            <div className="w-3 h-3 bg-orange-400 rounded-sm mr-2" data-id="element-384"></div>
            <span className="text-gray-600" data-id="element-385">CPL</span>
            <span className="ml-2 font-semibold text-gray-900" data-id="element-386">₹110.43</span>
          </div>
        </div>
      </div>

      <div className="relative h-80" data-id="element-387">
        {/* Y-axis labels for Leads (left) */}
        <div className="absolute left-0 top-0 bottom-8 flex flex-col justify-between text-xs text-gray-500 pr-2" data-id="element-388">
          <span data-id="element-389">4,500</span>
          <span data-id="element-390">3,500</span>
          <span data-id="element-391">2,500</span>
          <span data-id="element-392">1,500</span>
          <span data-id="element-393">500</span>
          <span data-id="element-394">0</span>
        </div>

        {/* Y-axis labels for CPL (right) */}
        <div className="absolute right-0 top-0 bottom-8 flex flex-col justify-between text-xs text-gray-500 pl-2" data-id="element-395">
          <span data-id="element-396">200</span>
          <span data-id="element-397">160</span>
          <span data-id="element-398">120</span>
          <span data-id="element-399">80</span>
          <span data-id="element-400">40</span>
          <span data-id="element-401">0</span>
        </div>

        {/* Chart area */}
        <div className="absolute left-12 right-12 top-0 bottom-8" data-id="element-402">
          {/* Grid lines */}
          <div className="absolute inset-0 flex flex-col justify-between" data-id="element-403">
            {[...Array(6)].map((_, i) => <div key={i} className="border-t border-gray-100" data-id="element-404"></div>)}
          </div>

          {/* Line chart */}
          <svg className="absolute inset-0 w-full h-full" preserveAspectRatio="none" data-id="element-405">
            {/* Leads line (blue) */}
            <polyline fill="none" stroke="#3b82f6" strokeWidth="2" points={MOCK_DATA.map((d, i) => {
            const x = i / (MOCK_DATA.length - 1) * 100;
            const y = 100 - d.leads / maxLeads * 100;
            return `${x}%,${y}%`;
          }).join(' ')} data-id="element-406" />
            {/* Leads points */}
            {MOCK_DATA.map((d, i) => {
            const x = i / (MOCK_DATA.length - 1) * 100;
            const y = 100 - d.leads / maxLeads * 100;
            return <circle key={`leads-${i}`} cx={`${x}%`} cy={`${y}%`} r="3" fill="#3b82f6" className="hover:r-5 transition-all cursor-pointer" data-id="element-407" />;
          })}

            {/* CPL line (orange) */}
            <polyline fill="none" stroke="#fb923c" strokeWidth="2" points={MOCK_DATA.map((d, i) => {
            const x = i / (MOCK_DATA.length - 1) * 100;
            const y = 100 - d.cpl / maxCpl * 100;
            return `${x}%,${y}%`;
          }).join(' ')} data-id="element-408" />
            {/* CPL points */}
            {MOCK_DATA.map((d, i) => {
            const x = i / (MOCK_DATA.length - 1) * 100;
            const y = 100 - d.cpl / maxCpl * 100;
            return <circle key={`cpl-${i}`} cx={`${x}%`} cy={`${y}%`} r="3" fill="#fb923c" className="hover:r-5 transition-all cursor-pointer" data-id="element-409" />;
          })}
          </svg>
        </div>

        {/* X-axis labels */}
        <div className="absolute bottom-0 left-12 right-12 flex justify-between text-xs text-gray-500" data-id="element-410">
          {MOCK_DATA.filter((_, i) => i % 4 === 0).map((d, i) => <span key={i} data-id="element-411">{d.date}</span>)}
        </div>
      </div>
    </div>;
}